import {
  ButtonClickEvent,
  ButtonClickEventParams,
} from './CommonButtonClickedEvent'
import { getConfigFor } from '../../../../utils/configService'
import { SPLIT_FEATURES } from '../../../../utils/constants/feature'
import { getCommonParams } from '../../utils/CommonParams'
import {
  BUSINESS_VERTICAL,
  EVENT_CATEGORY,
  BUTTON_NAME,
  BUTTON_TYPE,
} from '../../constants/EventHelper'
import { ButtonClickedEventSchema } from '../../schemas/buttonClickEvents/ButtonClickedsEventSchema'

export interface FindSimilarButtonClickedEventParams
  extends ButtonClickEventParams {}

export async function trackFindSimilarButtonClickEvent() {
  try {
    const { isEnabled = false } =
      getConfigFor(SPLIT_FEATURES.FE_ENGM_FIND_SIMILAR_BUTTON_CLICKED) || {}
    if (isEnabled) {
      const commonProperties = getCommonParams()
      const params: FindSimilarButtonClickedEventParams = {
        ...commonProperties,
        BUSINESS_VERTICAL: BUSINESS_VERTICAL.GROCERY,
        EVENT_CATEGORY: EVENT_CATEGORY.VOUCHER,
        BUTTON_NAME: BUTTON_NAME.FIND_SIMILAR,
        BUTTON_TYPE: BUTTON_TYPE.LINK_STYLE,
      }

      new ButtonClickEvent(params, ButtonClickedEventSchema).track()
    }
  } catch (error) {
    console.error('Error tracking Find Similar Button Clicked Event:', error)
  }
}
